// import React from "react";

// const HeadingCard = ({ item, styles }) => {
//   const coloum_value = JSON.parse(item?.coloum_value);
//   const fonts = styles?.filter((item)=>item.coloum_name === "fonts")?.[0]
//   const fontValue = fonts?.coloum_value && JSON.parse(fonts?.coloum_value);
//   return (
//     <div className="text-white flex flex-col w-full text-center gap-[30px]">
//       {(() => {
//         switch (item?.coloum_type) {
//           case "H1":
//             return (
//               <h1 style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-custom_h6 md:text-custom_h1 font-${fontValue?.fontType?.value}`}>{coloum_value?.coloum_value}</h1>
//             );
//           case "H2":
//             return (
//               <h2 style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-body_copy1_b md:text-custom_h2 font-${fontValue?.fontType?.value}`}>{coloum_value?.coloum_value}</h2>
//             );
//           case "H3":
//             return (
//               <h3 style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-body_copy2_black md:text-custom_h3 font-${fontValue?.fontType?.value}`}>{coloum_value?.coloum_value}</h3>
//             );
//           case "H4":
//             return (
//               <h4 style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small1_bold md:text-custom_h4 font-${fontValue?.fontType?.value}`}>{coloum_value?.coloum_value}</h4>
//             );
//           case "H5":
//             return (
//               <h5 style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small2_b md:text-custom_h5 font-${fontValue?.fontType?.value}`}>{coloum_value?.coloum_value}</h5>
//             );
//           case "H6":
//             return (
//               <h6 style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small3_b md:text-custom_h6 font-${fontValue?.fontType?.value}`}>{coloum_value?.coloum_value}</h6>
//             );
//           default:
//             return null;
//         }
//       })()}
//     </div>
//   );
// };

// export default HeadingCard;

import React from "react";
// import "./GlobalHeadingStyles.css"; // Import the global heading styles
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.bubble.css'

const HeadingCard = ({ item }) => {
  const coloum_value = JSON.parse(item?.coloum_value);

  if (!coloum_value || !coloum_value.coloum_value) {
    return null; // Handle the case when coloum_value is not available or doesn't have coloum_value property
  }

  const html = coloum_value.coloum_value;

  // const applyClassesToHtml = (html) => {
  //   // Regular expression to match opening <h1>, <h2>, <h3>, <h4>, <h5>, <h6> tags
  //   const regex = /<h([1-6])[^>]*>/g;

  //   // Replace all opening <hX> tags with the corresponding class
  //   const updatedHtml = html.replace(
  //     regex,
  //     (match, capturedGroup) =>
  //       `<h${capturedGroup} class='custom-h${capturedGroup.toLowerCase()}'>`
  //   );

  //   return updatedHtml;
  // };

  return (
    <div className="text-white flex flex-col w-full text-center gap-[30px]">
      {/* <div dangerouslySetInnerHTML={{ __html: applyClassesToHtml(html) }}></div> */}
      <ReactQuill value={html} readOnly={true} theme={"bubble"} style={{ border: "none"}}/>

    </div>
  );
};

export default HeadingCard;
